
import imagesLoaded from "imagesloaded";

export default function preloadImages(){
    const imgLoad = imagesLoaded(
        document.querySelectorAll("img"),
        {
            background: true,
        },
    );

    // Fires after images are loaded or confirmed broken.
    imgLoad.on('always', () => {
        removeCurtain();
    });

    // Fires after each image is loaded.
    imgLoad.on( 'progress', function( instance, image ) {
        const imageCount = instance.images.length;
        const current = instance.progressedCount;
        // if(imageCount && current){
        //     updateCurtainProgress((parseInt(current) / parseInt(imageCount)) * 100);
        // }
    });
}

// const updateCurtainProgress = (progress = 0) =>{
//     const curtainProgressEl = document.querySelector('.curtain .loading_progress');
//     if(!!curtainProgressEl){
//         curtainProgressEl.innerHTML = Math.round(progress) + '%';
//     }
// }

const removeCurtain = () => {
    const bodyEl = document.querySelector("body");
    const event = new CustomEvent("pageloaded");
    bodyEl.classList.remove("loading");
    window.dispatchEvent(event);

    setTimeout(() => {
        bodyEl.classList.add('loaded');
    }, 500);
}